const bar = document.querySelector(".category-bar");
const ele = document.querySelector(".category-bar .categories");
let pos = { top: 0, left: 0, x: 0, y: 0 };
let dirty = false;

const mouseDownHandler = function (e) {
    ele.style.cursor = "grabbing";
    ele.style.userSelect = "none";

    pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
    };

    document.addEventListener("mousemove", mouseMoveHandler);
    document.addEventListener("mouseup", mouseUpHandler);
};

const mouseUpHandler = function () {
    document.removeEventListener("mousemove", mouseMoveHandler);
    document.removeEventListener("mouseup", mouseUpHandler);

    ele.style.cursor = "grab";
    ele.style.removeProperty("user-select");
};

function scrollHandler() {
    if (dirty) {
        window.removeEventListener("scroll", scrollHandler);
        return;
    }
    ele.classList.remove("reveal");
    dirty = true;
}

const mouseMoveHandler = function (e) {
    // How far the mouse has been moved
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;

    // Scroll the element
    ele.scrollTop = pos.top - dy;
    ele.scrollLeft = pos.left - dx;

};

export function dragToScroll() {
    if (!dirty) {
        ele.classList.add("reveal");
    }
    ele.addEventListener("mousedown", mouseDownHandler);
    window.addEventListener("scroll", scrollHandler);
}
